import HttpCLient from '@/src/lib/utils/httpClient';
import { ApiRouts } from '@/src/routes/routes';
import { Prime } from '@/src/types/prime';
import { cache } from 'react';

export class PrimeServices extends HttpCLient {
  getPrime = cache(async () => {
    return await this.get<Prime>(ApiRouts.prime, undefined, {
      next: {
        tags: ['prime'],
        revalidate: 60 * 60 * 24, // 24 hours
      },
    });
  });
}
export const primeServices = new PrimeServices();
